var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('p',{class:_vm.$style['footer-copyright']},[_vm._v(" Copyright © 2023 Zetrix. All rights reserved. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }